<mode-nav-menu-container target="_self"> </mode-nav-menu-container>

<header
  capra-header
  [navOpen]="navOpen$ | async"
  [showHamburger]="(navOpen$ | async) === false"
  (navToggleClick)="openNav()"
>
  <mode-workspace-avatar
    capra-header-avatar
    *ngIf="reportContext$ | async as reportContext"
    shape="square"
    [type]="reportContext.avatar.type"
    [initials]="reportContext.avatar.initials"
    [colorClass]="reportContext.avatar.colorClass"
    [imageSrc]="reportContext.avatar.href"
    [imageName]="reportContext.name"
    [isCommunity]="reportContext.user"
  ></mode-workspace-avatar>
  <ng-container capra-header-details>
    <mode-breadcrumbs class="breadcrumbs" [breadcrumbs]="reportBreadcrumbs$ | async"></mode-breadcrumbs>
    <div class="actions">
      <a class="action-link first" modeLegacyRouterLink="details">View Details</a>
      <a class="action-link" [modeLegacyRouterLink]="['/editor', orgName, 'reports', reportToken]" target="_self"
        >Edit</a
      >
      <a class="action-link">Share</a>
      <a class="action-link">Export</a>
      <a class="action-link">Clone</a>
      <a class="action-link">More</a>
      <div class="action-run-info" *ngIf="report$ | async as report">
        <span class="bullet">&bullet;</span>
        Run <mode-time-ago [date]="report.last_run_at"> </mode-time-ago>
      </div>
      <a class="action-link" *ngIf="(report$ | async)?.manualRunDisabled === false">Run Now</a>
    </div>
  </ng-container>

  <ng-container capra-header-right>
    <mode-user-access-avatar
      *ngIf="userContext$ | async as userContext"
      [avatar]="userContext.avatar"
    ></mode-user-access-avatar>
    <mode-header-search
      display="button"
      theme="dark"
    ></mode-header-search>

    <mode-report-creation-menu
      [org]="(orgContext$ | async)?.usename"
    ></mode-report-creation-menu>

    <mode-help-menu
      [isGuest]="(isLoggedIn$ | async) === false"
      [isCommunity]="(orgContext$ | async)?.user ?? false"
      theme="dark"
    ></mode-help-menu>
  </ng-container>
</header>

<router-outlet></router-outlet>
